(function () {

    /**
     * Shortcuts to access Underscore.String functions.
     */
    _.str = _.string = _.s = s;

    // Will take a path like 'element[0][1].subElement["Hey!.What?"]["[hey]"]'
    // and return ["element", "0", "1", "subElement", "Hey!.What?", "[hey]"]
    function keysFromPath(path) {
        // from http://codereview.stackexchange.com/a/63010/8176
        /**
         * Repeatedly capture either:
         * - a bracketed expression, discarding optional matching quotes inside, or
         * - an unbracketed expression, delimited by a dot or a bracket.
         */
        var re = /\[("|')(.+)\1\]|([^.\[\]]+)/g;

        var elements = [];
        var result;
        while ((result = re.exec(path)) !== null) {
            elements.push(result[2] || result[3]);
        }
        return elements;
    }

    function objectDeepContainsStr(object, string) {
        if (object == null) {
            return false;
        } else if (_.isString(object)) {
            return _.str.include(object.toLowerCase(), string.toLowerCase());
        } else if (_.isArray(object)) {
            return _.some(object, function (subEl) {
                return objectDeepContainsStr(subEl, string);
            });
        } else if (_.isObject(object)) {
            return _.some(_.values(object), function (subEl) {
                return objectDeepContainsStr(subEl, string);
            });
        } else if (_.isDate(object) || _.isNumber(object)) {
            var str = object.toString ? object.toString() : "";
            return _.str.include(str.toLowerCase(), string.toLowerCase());
        } else {
            return false;
        }
    }

    _.mixin({

        /**
         * Deep search string in JSON object or Array
         *
         * @static
         * @memberOf _
         * @category Objects
         * @param {*} object
         * @param {string} string
         * @returns {boolean} true if string was found somewhere inside JSON object tree
         */
        objectDeepContainsStr: objectDeepContainsStr,

        /**
         * Filter Array of objects by string, checking every element if it contains
         * string field that has substring as 2nd parameter string
         *
         * @static
         * @memberOf _
         * @category Arrays
         * @param {Array<*>} array
         * @param {string} string string to search
         * @returns {Array<*>} filtered array
         */
        deepFilterByStr: function (array, string) {
            if (!array || !_.isArray(array)) {
                return array;
            }
            return _.filter(array, function (el) {
                return objectDeepContainsStr(el, string);
            });
        },

        /**
         * Remove all object members (without creating another object)
         *
         * @static
         * @memberOf _
         * @category Objects
         * @param {*} obj object
         * @returns {*} empty object from arguments
         */
        clearObject: function (obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    delete obj[prop];
                }
            }
            return obj;
        },

        clearObjectProps: function(obj, propertyName) {
            if (_.isArray(propertyName)) {
                for (var p = 0; p < propertyName.length; p++) {
                    _.clearObjectProps(obj, propertyName[p]);
                }
            } else {
                for (var i in obj) {
                    if (!obj.hasOwnProperty(i)) continue;
                    if (i === propertyName) {
                        delete obj[propertyName];
                    } else if (typeof obj[i] == 'object') {
                        _.clearObjectProps(obj[i], propertyName);
                    }
                }
            }
            return obj;
        },

        /**
         * Object resetting. Clears object from first argument(removing all properties), and copy all properties from second argument to first one
         *
         * @static
         * @memberOf _
         * @category Objects
         * @param {*} targetObj object to reset. Will be cleared and extended from second argument, and then returned
         * @param {*} sourceObj source object. Will not change
         * @returns {*} first argument, cleared and refilled
         */
        resetObject: function (targetObj, sourceObj) {
            return _.extend(_.clearObject(targetObj), sourceObj)
        },

        /**
         * Checks if `value` is a promise.
         *
         * @static
         * @memberOf _
         * @category Objects
         * @param {*} [value] The value to check.
         * @returns {boolean} Returns `true` if the `value` is a promise, else `false`.
         * @example
         *
         * _.isPromise($q.when(something));
         * // => true
         */
        isPromise: function (value) {
            return !!value && _.isFunction(value.then);
        },

        /**
         * Iterate through tree
         * @param {Object|Array} treeRoot root of the tree
         * @param {string} [itemsFieldName] field with sub elements
         * @param {function} [beforeFunc] function that will be called before iterating through tree node
         * @param {function} [afterFunc] function that will be called after iterating through tree node
         */
        iterateTree: function (treeRoot, itemsFieldName, beforeFunc, afterFunc) {
            itemsFieldName = itemsFieldName || "items";
            if (_.isArray(treeRoot)) {
                _.forEach(treeRoot, function (subEl) {
                    iterateTreeRecursive(subEl);
                });
            } else {
                iterateTreeRecursive(treeRoot);
            }
            return treeRoot;

            function iterateTreeRecursive(element) {
                if (beforeFunc) beforeFunc(element);
                if (element[itemsFieldName]) {
                    _.forEach(element[itemsFieldName], function (subEl) {
                        iterateTreeRecursive(subEl);
                    });
                }
                if (afterFunc) afterFunc(element);
            }
        },

        // Gets the value at any depth in a nested object based on the
        // path described by the keys given. Keys may be given as an array
        // or as a dot-separated string.
        getPath: function getPath(obj, ks) {
            ks = typeof ks == "string" ? keysFromPath(ks) : ks;

            var i = -1, length = ks.length;

            // If the obj is null or undefined we have to break as
            // a TypeError will result trying to access any property
            // Otherwise keep incrementally access the next property in
            // ks until complete
            while (++i < length && obj != null) {
                obj = obj[ks[i]];
            }
            return i === length ? obj : void 0;
        },

        // Returns a boolean indicating whether there is a property
        // at the path described by the keys given
        hasPath: function hasPath(obj, ks) {
            ks = typeof ks == "string" ? keysFromPath(ks) : ks;

            var i = -1, length = ks.length;
            while (++i < length && _.isObject(obj)) {
                if (ks[i] in obj) {
                    obj = obj[ks[i]];
                } else {
                    return false;
                }
            }
            return i === length;
        },

        // Deep pluck version
        pluck: function pluck(arr, key) {
            return _.map(arr, function (o) {
                return _.getPath(o, key);
            });
        },

        /**
         * Version of classic debounce with one additional thing: if debounced function called repeatedly more then
         * `waitLimit` ms, then the function will be called anyway after `waitLimit` ms after first call.
         * @param {function} func the debounced function
         * @param {number} wait debounce interval
         * @param {number} [waitLimit] maximum timeout before calling the debounced function
         * @return {Function}
         */
        debounceLimited: function (func, wait, waitLimit) {
            var timeout;
            var waitLimitTimeout;
            return function () {
                var context = this;
                var args = arguments;
                var later = function () {
                    clearTimeout(timeout);
                    clearTimeout(waitLimitTimeout);
                    waitLimitTimeout = null;
                    timeout = null;
                    func.apply(context, args);
                };
                if (!waitLimitTimeout && waitLimit) {
                    waitLimitTimeout = setTimeout(later, waitLimit);
                }
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },

        isPlainObject: function (obj) {
            return obj !== undefined && obj !== null && obj.constructor === Object;
        },

        /**
         * Clone object deeply
         * @param {*} object object to clone
         * @return {*}
         */
        cloneDeep: function (object) {
            //TODO: We need periodically check that nobody clones RepresentationModel. (i.e.if we don't have representation models as FieldType.DYNAMIC)
            //if (object && object.isRepresentationModel) {
            //    console.warn('Attempt to clone RepresentationModel instance!');
            //}
            return window["fast-copy"](object);
        }
    });


})();
